import { jsx as o } from "react/jsx-runtime";
import { Tooltip as t } from "../Tooltip/Tooltip.js";
import { Close as i } from "../../foundations/icons/Close.js";
const d = ({
  className: r,
  cx: e,
  innerProps: l
}) => /* @__PURE__ */ o(t, { tooltip: "Remove all", delay: 300, children: /* @__PURE__ */ o(
  "div",
  {
    ...l,
    className: e({ indicator: !0, "clear-indicator": !0 }, r),
    role: "button",
    "aria-label": "Remove all",
    children: /* @__PURE__ */ o(i, {})
  }
) });
export {
  d as ClearIndicator
};
//# sourceMappingURL=ClearIndicator.js.map
